/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:e7053f68-c5f3-4165-9f93-826ef7e897a0",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_1SDygZJGf",
    "aws_user_pools_web_client_id": "7h1sqb7om5sqkm0sms91oan7j6",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://l3rsc3jmkffc5kfio2wyoju5zm.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "stripewebhook",
            "endpoint": "https://ppwqsz0zc3.execute-api.eu-central-1.amazonaws.com/prod",
            "region": "eu-central-1"
        },
        {
            "name": "webhookapi",
            "endpoint": "https://sadhgkfuac.execute-api.eu-central-1.amazonaws.com/prod",
            "region": "eu-central-1"
        }
    ],
    "aws_user_files_s3_bucket": "soda-vc149343e68e240dba511955bd41c8b00-prod",
    "aws_user_files_s3_bucket_region": "eu-central-1",
    "aws_mobile_analytics_app_id": "e56b3bca901b42f58113e310325605ba",
    "aws_mobile_analytics_app_region": "eu-central-1"
};


export default awsmobile;
